import { render, staticRenderFns } from "./PairEvent.vue?vue&type=template&id=07df578b&"
import script from "./PairEvent.vue?vue&type=script&lang=js&"
export * from "./PairEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports